import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import { ASSETS } from "@/lib/constants";

const { wordmark: WORDMARK } = ASSETS;

export default function LegalLayout({ title, eyebrow, lastUpdated, children }) {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      {/* Slim header */}
      <header className="border-b border-white/10 bg-black/80 backdrop-blur-md sticky top-0 z-40">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 h-16 flex items-center justify-between">
          <Link
            to="/"
            data-testid="legal-back-home"
            className="flex items-center gap-3 group"
          >
            <div className="relative overflow-hidden h-10 w-[180px] sm:w-[200px] select-none">
              <img
                src={WORDMARK}
                alt="Stable-ish"
                draggable="false"
                className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 max-w-none pointer-events-none"
                style={{ height: "260px" }}
              />
            </div>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-3 py-2 border border-white/15 hover:border-[#FF2A2A] hover:text-[#FF2A2A] font-mono text-[10px] uppercase tracking-[0.22em] text-white/80 transition-colors"
            data-testid="legal-back-button"
          >
            <ArrowLeft size={12} weight="bold" />
            Back to site
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="max-w-[760px] mx-auto px-5 md:px-8 py-16 md:py-24">
        {eyebrow && (
          <p className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-5">
            {eyebrow}
          </p>
        )}
        <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tighter leading-[0.95]">
          {title}
        </h1>
        {lastUpdated && (
          <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.22em] text-white/40">
            {lastUpdated}
          </p>
        )}
        <div className="mt-10 prose-stableish">{children}</div>

        <div className="mt-20 pt-8 border-t border-white/10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.22em] text-white/60 hover:text-[#FF2A2A] transition-colors"
          >
            <ArrowLeft size={12} weight="bold" />
            Back to stableish.me
          </Link>
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/35">
            © {new Date().getFullYear()} Stable-ish LLC
          </p>
        </div>
      </main>

      {/* Disclaimer band */}
      <div className="border-t border-[#FF2A2A]/40 bg-[#FF2A2A]/[0.04]">
        <div className="max-w-[1200px] mx-auto px-5 md:px-10 py-5">
          <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-[#FF2A2A]">
            ⚠ not a substitute for clinical judgment · verify with institutional protocol
          </p>
        </div>
      </div>
    </div>
  );
}
